import { DataExportStatus } from './types';

/**
 * How often to poll `GET /v1/charge/data-export` while a job is still building. Matches the
 * notifications polling cadence (15s). Polling is additionally gated on app visibility and on
 * there being at least one active job — see `DataArchive`.
 */
export const DATA_EXPORT_POLLING_TIME_MS = 15_000;

/** Statuses for which the export is still being built and the list should keep polling. */
export const ACTIVE_DATA_EXPORT_STATUSES: DataExportStatus[] = ['PENDING', 'IN_PROGRESS'];
